import React from "react";
import { Box, BoxProps } from "@mui/material";

// A page-section wrapper. Currently flat — no border, shadow or padding — so sections sit directly on
// the page with no extra card frame or margin. Kept as a component (rather than inlining a Box) so the
// card look can be restored in one place if wanted; callers pass content and styling through sx.
const SectionPaper = ({ sx, children, ...props }: BoxProps) => (
  <Box sx={sx} {...props}>
    {children}
  </Box>
);

export default SectionPaper;
